export const listAttrs = [
    {
        'dir': 'most_viewed',
        'title': 'MOST-VIEWED',
        'postnames': [
            'how-does-recommendation-algorithms-work-using-surpriselib',
            'how-to-build-a-data-science-portfolio',
            'evaluation-metrics-for-recommendation-system',
            'back-propagation',
            'basic-of-metaflow',
        ],
    },
    {
        'dir': 'tech_blog',
        'title': 'TECH',
    },
    // {
    //   'dir': 'food_blog',
    //   'title': 'FOOD',
    // },
]

function makeCoupangAdsIframe(iframe_url, a_url) {
    let iframe_prefix = '<iframe src="',
        iframe_suffix = '" width="120" height="240" frameborder="0" scrolling="no"></iframe>',
        iframe = iframe_prefix + iframe_url + iframe_suffix,
        a_prefix_a = '<a class="coupangLink--a" href="',
        a_prefix_b = '" target="_blank">',
        a_suffix = '</a>'

    return a_prefix_a + a_url + a_prefix_b + a_suffix + iframe
}

export const blogType2coupangAds = {
    "tech_blog": [
        makeCoupangAdsIframe('https://coupa.ng/bKWKJU', 'https://coupa.ng/bKWRmi'),
        makeCoupangAdsIframe('https://coupa.ng/bKWKFy', 'https://coupa.ng/bKWRm4'),
        makeCoupangAdsIframe('https://coupa.ng/bKWKHI', 'https://coupa.ng/bKWRgF'),       
    ],
    "food_blog": [],
}
